import _ from "lodash";

import {
  Component,
} from "react";
import {
  Button,
} from "react-bootstrap";
import {
  Awesome,
  Panel,
} from "CommonComponents/bricks";
import ApiComponent from "CommonComponents/api-component";
import Confirmation from "CommonComponents/confirmation";
import apifetch from "CommonCore/apifetch";

import {
  schema as personSchema,
} from "Apis/person-api";
import {
  schema as studienbereichSchema,
} from "Apis/person-studienbereich-api";
import {
  schema as werdegangSchema,
} from "Apis/person-werdegang-api";

class AenderungenButton extends Component {
  constructor() {
    super();
    this.state = {};
  }

  closePopup = () => {
    this.setState({ popup: null });
  };

  render() {
    const { data } = this.props;
    const { popup } = this.state;
    if (data && data.differenz == true) {
      return <Panel>
        {popup && <AenderungenPopup aenderungen={data} onClose={this.closePopup} />}

        <h3>Änderungsmitteilung</h3>
        <p>Sollten Sie umgezogen sein oder eine neue Bankverbindung angeben wollen oder andere persönliche Daten sich geändert haben, können Sie diese einfach in dem Bereich "Persönliche Angaben" ändern.</p>
        <p>Anschließend haben Sie die Möglichkeit, über unten stehende Schaltfläche diese Änderungen dem Personaldezernat mitzuteilen</p>
        <br />
        <div className='text-center'><Button variant='outline-primary' onClick={() => this.setState({ popup: true })}>Änderungsmitteilung für Personaldezernat</Button></div>

      </Panel>;
    }
    return null;
  }
}

export default class DashboardWidgetAenderungen extends Component {
  constructor() {
    super();
    this.state = { updateid: 0 };
  }

  render() {
    return <ApiComponent
      url='/api/shkantrag/aenderung/nutzer'
      plainObject
      component={AenderungenButton} />;
  }
}

class AenderungenPopup extends Component {
  constructor() {
    super();
    this.state = { confirm: 0 };
  }

  render() {
    const { onClose, aenderungen } = this.props;
    const { errorMessage } = this.state;

    const bereiche = [{ key: "person", label: "Person", schema: personSchema },
                      { key: "studienbereich", label: "Studienbereich", schema: studienbereichSchema },
                      { key: "werdegang", label: "Werdegang", schema: werdegangSchema }];

    if (this.state.confirm == 0) {
      return <Confirmation
        header='Änderungen an Personaldezernat melden'
        action='Änderungen melden'
        actionStyle='primary'
        onCancel={onClose}
        onConfirm={this.onConfirm}
        errorMessage={errorMessage}
      >
        Folgende Änderungen können an das Personaldezernat weitergeleitet werden:

        {_.map(bereiche, bereich => {
          if (_.isEmpty(aenderungen[bereich.key])) {
            return null;
          }
          return <span><h4>{bereich.label}</h4><ul> {_.map(Object.keys(aenderungen[bereich.key][0]), fld => {
            const data = aenderungen[bereich.key][0][fld];
            if (_.isObject(data)) {
            // Object mit alt/neu
              const def = bereich.schema.table.find(x => x.field == fld);
              if (def) {
                return <li><em>{def.display}</em>: {data.alt} <Awesome name='arrow-right' /> {data.neu}</li>;
              }
            }
          })}</ul></span>;
        })}

      </Confirmation>;
    }

    return <Confirmation
      header='Änderungen an Personaldezernat melden'
      action='Ok'
      actionStyle='primary'
      onCancel={onClose}
      onConfirm={this.onConfirmOk}
      errorMessage={errorMessage}
    >
      Änderungen wurden übermitelt.
    </Confirmation>;
  }

  onConfirm = async() => {
    try {
      await apifetch("/api/shkantrag/aenderung/nutzer", { method: "POST" });
      // this.props.onClose()
      this.setState({ confirm: 1 });
    } catch(err) {
      this.setState({
        errorMessage: err.response && (err.response.nachricht || err.response.um)
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
  onConfirmOk = () => {
    this.props.onClose();
  };
}

